<template>
  <b-modal id="add-contact-modal" title="Add Contact" hide-footer>
    <loading-screen :is-loading="isSaving"></loading-screen>
    <errors :error-list="serverErrors"></errors>

    <b-tabs pills>
      <b-tab title="Add existing contact" active>
        <!-- Add existing contact -->
        <div class="pt-4">
          <!-- Search box -->
          <div class="search-box">
            <div class="position-relative">
              <input v-model="searchQuery" type="text" class="form-control"
                     placeholder="Search for contact..."/>
              <i class="bx bx-search-alt search-icon"></i>
            </div>
          </div>
          <!-- / Search box -->

          <div v-if="isLoading||searchQueryIsDirty" class="text-center mt-4">
            <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
          </div>

          <div v-if="!(isLoading||searchQueryIsDirty) && searchQuery.length"
               class="table-responsive mb-0 mt-4">
            <table class="table mb-0 table-centered">
              <thead class="thead-light">
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="contact in contactResults">
                <th scope="row">{{ contact.first_name }}</th>
                <td>{{ contact.last_name }}</td>
                <td>{{ contact.email }}</td>
                <td>{{ contact.phone_number }}</td>
                <td class="text-right">
                  <!-- Button trigger modal -->
                  <button
                      type="button"
                      class="btn btn-itg btn-itg btn-sm"
                      @click="selectContact(contact)"
                  >
                    Select
                  </button>
                </td>
              </tr>
              <tr v-if="contactResults.length === 0">
                <th scope="row" colspan="5">
                  <span class="text-danger">No results</span>
                </th>
              </tr>
              </tbody>
            </table>
          </div>

          <pagination v-if="!(isLoading||searchQueryIsDirty) && contacts" :data="contacts" :limit="8"
                      @pagination-change-page="searchContacts"></pagination>

        </div>
        <!-- / Add existing contact -->
      </b-tab>

      <b-tab title="+ Create new contact">
        <!-- Create new contact -->
        <div class="pt-4">
          <form @submit.prevent="createNewContact">

            <div class="form-group mb-4">
              <label for="firstNameInput">First Name</label>
              <input type="text" v-model="newContact.first_name" id="firstNameInput" class="form-control">
            </div>

            <div class="form-group mb-4">
              <label for="lastNameInput">Last Name</label>
              <input type="text" v-model="newContact.last_name" id="lastNameInput" class="form-control">
            </div>

            <div class="form-group mb-4">
              <label for="emailInput">Email</label>
              <input type="email" v-model="newContact.email" id="emailInput" class="form-control">
            </div>

            <div class="form-group mb-4">
              <label for="phoneInput">Phone</label>
              <input type="tel" v-model="newContact.phone_number" id="phoneInput" class="form-control">
            </div>

            <button type="submit" class="btn btn-itg-dark" :disabled="isSaving"
                    @click.prevent="createNewContact">Create
              Contact
            </button>

          </form>
        </div>
        <!-- / Create new contact -->
      </b-tab>
    </b-tabs>

  </b-modal>
</template>

<script>
import axios from "axios";
import Forms from "../../../../../mixins/Forms";

export default {
  name: "AddContactModal",
  props: ['ticketId'],
  data() {
    return {
      searchQuery: '',
      searchQueryIsDirty: false,
      contacts: null,
      isLoading: false,
      isSaving: false,
      serverErrors: [],

      newContact: {
        first_name: '',
        last_name: '',
        email: '',
        phone_number: ''
      }
    }
  },
  mixins: [Forms],
  watch: {
    searchQuery: function () {
      this.searchQueryIsDirty = true;
      this.searchContacts();
    }
  },
  methods: {
    searchContacts(page = 1) {
      let vm = this;
      vm.serverErrors = [];
      vm.isLoading = true;

      axios.post(API_BASE + '/contacts/search', {
        page: page,
        q: vm.searchQuery
      }).then(r => {
        vm.isLoading = false;
        vm.contacts = r.data;
        vm.searchQueryIsDirty = false;
      }).catch(e => {
        console.log(e);
        vm.isLoading = false;
        vm.setErrors(e);
      });
    },

    selectContact(contact) {
      let vm = this;
      vm.isSaving = true;
      axios.post(API_BASE + '/tickets/' + vm.ticketId + '/contacts/' + contact.id).then(r => {
        vm.isSaving = false;
        this.$notify.success({
          title: 'Success!',
          message: 'Contact added successfully'
        });
        this.$emit('contact-added');
        this.$bvModal.hide('add-contact-modal');
      }).catch(e => {
        vm.isSaving = false;
        vm.setErrors(e);
      });
    },

    createNewContact() {
      let vm = this;
      vm.serverErrors = [];
      vm.isSaving = true;

      axios.post(API_BASE + '/contacts', vm.newContact).then(r => {
        vm.isSaving = false;
        vm.newContact = {
          first_name: '',
          last_name: '',
          email: '',
          phone_number: ''
        };
        vm.selectContact(r.data);
      }).catch(e => {
        console.log(e);
        vm.isSaving = false;
        vm.setErrors(e);
      });
    }
  },
  computed: {
    contactResults() {
      if (this.contacts) {
        return this.contacts.data;
      }
      return [];
    }
  }
}
</script>

<style scoped>

</style>
